module.exports = __webpack_public_path__ + "static/karl-6d48523e016ec2a5e440274e5ce2b712.png";